import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="w-full bg-white px-5 py-6 sm:py-12" data-id="element-170" data-mp="22l5dz2tolmka">
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.4
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-171" data-mp="22mq3uf51whbt">
        <span className="mb-4 inline-block rounded-full border border-cobalt/40 bg-cobalt/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-cobalt-deep sm:mb-5" data-id="element-172" data-mp="2ge4qcvy630nm">
          📦 Tutto ciò che contiene il sistema
        </span>
        <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-173" data-mp="26l5xv2zjupyq">
          Tutto il necessario per insegnare chimica in modo più visivo, organizzato ed efficace
        </h2>
        <p className="mt-3 text-sm font-medium text-cobalt-deep sm:mt-5 sm:text-lg" data-id="element-174" data-mp="342e73jgiwy7w">
          CHIMICA VISIVA™ — Il sistema completo pensato per i docenti di chimica in Italia
        </p>
        <div className="mx-auto mt-4 h-px w-16 bg-cobalt/40 sm:mt-6" data-id="element-175" data-mp="udc74ejhw840" />
        <p className="mt-4 text-sm leading-relaxed text-ink/70 sm:mt-6 sm:text-base" data-id="element-176" data-mp="pi58hl531tly">
          CHIMICA VISIVA™ riunisce in un’unica raccolta materiali pronti per la classe dedicati alla
          materia, alla struttura atomica, alla periodicità, ai legami chimici, alle reazioni, alla
          stechiometria, alla chimica organica, alle biomolecole e alle applicazioni scientifiche.
        </p>
      </motion.div>
    </section>;
}